const ROOM_TYPES = [
  {
    name: 'Private Office',
    size: 150,
    estimate: (num) => Math.ceil(num / 5),
    color: '#ebebeb',
  },
  {
    name: 'Conference Room',
    size: 250,
    estimate: (num) => Math.ceil(num / 10),
    color: '#bef6ff',
  },
  {
    name: 'Kitchen',
    size: 200,
    estimate: (num) => (num > 10 ? Math.ceil(num / 50) : 0),
    color: '#ff5050',
  },
  {
    name: 'Utility Room',
    size: 300,
    estimate: (num) => (num > 20 ? Math.ceil(num / 100) * 2 : 0),
    color: '#F3B855',
  },
];

export default ROOM_TYPES;
